enum ActionTypes {
  RESET_COMPANY_SETTINGS = "app/company/RESET_COMPANY_SETTINGS",
  SET_COMPANY_SETTINGS = "app/company/SET_COMPANY_SETTINGS",
  SET_LOGIN_OPTIONS = "app/company/SET_LOGIN_OPTIONS",
}

export default ActionTypes;
